"use client";

import { Col, Container, Row } from "react-bootstrap";
import { BsChatDots } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import styled from "styled-components";

const CallToAction = () => {
  const phoneNumber = `070 915 5510`;
  const whatsappNumber = `079 222 5552`;
  const phoneUrl = `tel:${phoneNumber.replace(/\s/g, "")}`;
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/\s/g, "")}`;
  const locationUrl = "https://maps.app.goo.gl/kjErDpEiHv85nrh8A";

  return (
    <CTASection>
      <Container>
        <Row className="text-center mb-5">
          <Col>
            <Heading>Ready to start earning?</Heading>
            <SubText>
              Call us, WhatsApp, or visit our office. We're here to help.
            </SubText>
          </Col>
        </Row>
        <Row className="g-4 g-lg-5">
          <Col xs={12} lg={4}>
            <CallCard href={phoneUrl}>
              <IconWrapper>📱</IconWrapper>
              <ContentWrapper className="text-white">
                <CardTitle style={{ color: "#b8b8b8" }}>Call Us</CardTitle>
                <CardValue className="card_value">{phoneNumber}</CardValue>
              </ContentWrapper>
            </CallCard>
          </Col>
          <Col xs={12} lg={4}>
            <WhatsappCard
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              <IconWrapper>
                <BsChatDots />
              </IconWrapper>
              <ContentWrapper>
                <CardTitle>Whatsapp</CardTitle>
                <CardValue className="card_value">{whatsappNumber}</CardValue>
              </ContentWrapper>
            </WhatsappCard>
          </Col>
          <Col xs={12} lg={4}>
            <VisitCard
              href={locationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              <IconWrapper>
                <CiLocationOn />
              </IconWrapper>
              <ContentWrapper>
                <CardTitle>Visit Us</CardTitle>
                <CardValue className="card_value">Glive Garage</CardValue>
              </ContentWrapper>
            </VisitCard>
          </Col>
        </Row>
      </Container>
    </CTASection>
  );
};

export default CallToAction;

const CTASection = styled.section`
  background-color: #2d2d2d;
  padding: 80px 0 120px 0;

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

const Heading = styled.h2`
  color: #ffffff;
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const SubText = styled.p`
  color: #b8b8b8;
  font-size: 1rem;
  margin-bottom: 1rem;
`;

const CTACard = styled.a`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 30px;
  border-radius: 8px;
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
    text-decoration: none;
  }

  @media (max-width: 768px) {
    padding: 20px;
    gap: 15px;
  }
`;

const CallCard = styled(CTACard)`
  background-color: #373433;

  &:hover .card_value {
    text-decoration: underline;
  }
`;

const WhatsappCard = styled(CTACard)`
  background-color: #10a049;

  &:hover .card_value {
    text-decoration: underline;
  }
`;

const VisitCard = styled(CTACard)`
  background-color: #d6b048;

  &:hover .card_value {
    text-decoration: underline;
  }
`;

const IconWrapper = styled.div`
  font-size: 5rem;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const CardTitle = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 5px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const CardValue = styled.div`
  font-size: 1.5rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;
